import * as THREE from "three";

const mod = () => {
  const raycaster = new THREE.Raycaster();

  const modelsInScene = {};
  return {
    addObjectForIntersection: (modelId, threeObject) => {
      modelsInScene[modelId] = threeObject;
    },
    checkIntersection: (camera, normalizedClickPos) => {
      const result = {};
      if (camera == null) return result;
      raycaster.setFromCamera(normalizedClickPos, camera);
      Object.keys(modelsInScene).forEach((modelId) => {
        const intersectedObjects = raycaster.intersectObjects(
          [modelsInScene[modelId]],
          true
        );
        if (intersectedObjects.length > 0) {
          // console.log(
          //   "clicked",
          //   normalizedClickPos,
          //   intersectedObjects[0].point,
          //   intersectedObjects
          // );
          result[modelId] = intersectedObjects[0].point;
        }
      });
      return result;
    },
  };
};

const RaycasterHelper = mod();
export default RaycasterHelper;
